<template>
  <div class="card is-min-width-500">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('produitPresse.encarts.popUpFormatPresse.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="columns is-multiline">
        <b-field
          :label="$t('produitPresse.encarts.popUpFormatPresse.typeFormatPresse')"
          class="column is-12">
          <b-autocomplete
            v-model="searchTypeFormatPresse"
            :data="typesFormatPresse"
            :loading="isFetching"
            field="libelle"
            icon="magnify"
            @select="setTypeFormatPresse"
            @input="getTypeFormatPresse"
            open-on-focus>
            <template slot="empty">
              <div v-if="!isFetching">
                {{$t('general.autocomplete.noRslt')}}
              </div>
              <div v-else>
                {{$t('general.autocomplete.search')}}
              </div>
            </template>
            <template slot-scope="props">
              {{ `${props.option.code} ${props.option.libelle}
              (${props.option.typeFormatPresseLignes.length})` }}
            </template>
          </b-autocomplete>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <button class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </button>
          </div>
          <div class="is-pulled-left boutonAction">
            <button
              class="button is-addOrEdit"
              @click="apply"
              :disabled="!typeFormatPresseSelected">
              {{ $t('general.button.apply') }}
            </button>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import { getAll } from '@/api/presse/typeFormatPresse/';
import messageErreur from '@/services/general/messageErreur';

export default {
  props: {},
  data() {
    return {
      typesFormatPresse: [],
      searchTypeFormatPresse: '',
      typeFormatPresseSelected: null,
      isFetching: false,
    };
  },
  methods: {
    apply() {
      this.$emit('apply', this.typeFormatPresseSelected);
      this.$parent.close();
    },
    async getTypeFormatPresse(text) {
      if (!text) return;
      try {
        this.isFetching = true;
        this.typesFormatPresse = (await getAll({ query: { auto: text } }))
          .data.result.items;
        this.isFetching = false;
      } catch (e) {
        this.isFetching = false;
        messageErreur(this.$i18n);
        throw e;
      }
    },
    setTypeFormatPresse(typeFormatPresse) {
      if (!typeFormatPresse) return;
      this.typeFormatPresseSelected = typeFormatPresse;
      this.searchTypeFormatPresse = typeFormatPresse.libelle;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.typesFormatPresse = (await getAll({ query: { auto: '' } }))
        .data.result.items;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
